import './App.css';
import Header from './components/Header';
import WeGotYou from './components/WeGotYou';
import TrustedBy from './components/TrustedBy';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import FeatureSectionLandingPage from './components/FeatureSectionLandingPage';
import TechPartners from './components/TechPartners';
import ContactForm from './components/ContactForm';
import CustomerPortal from './components/CustomerPortal';

function App() {
  return (
    <div className="App">
      <Header/>
      <main>
        <FeatureSectionLandingPage/>
        <TechPartners/>
        <WeGotYou/>
        <TrustedBy/>
        <CustomerPortal/>
        <FAQSection/>
        <ContactForm/>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
